import {announce} from '@react-aria/live-announcer'
import {addIntegration, tanstackRouterBrowserTracingIntegration} from '@sentry/react'
import {useScript} from '@unhead/react'
import {Toaster} from 'sonner'

import AuthEffects from '@/auth/components/AuthEffects'
import {loadSentryIntegrations} from '@/instrument'
import BookmarkUpdater from '@/lib/bookmark/components/BookmarkUpdater'
import CartEffects from '@/lib/cart/components/CartEffects'
import LocaleUpdater from '@/lib/locale/components/LocaleUpdater'
import ThemeEffects from '@/lib/theme/ThemeEffects'
import {CssVariableEffects} from '@/utils/components/CssVariableChange'
import RouteAnnouncer from '@/utils/router/RouteAnnouncer'

import {COBROWSE_SCRIPT, DEBUG} from './constants/config'
import InAppEffects from './lib/in-app/InAppEffects'
import isInApp from './lib/in-app/utils/isInApp'
import ReloadIfNotUsingStripeAnymore from './lib/payment/components/ReloadIfNotUsingStripeAnymore'

const GoogleOneTapLogin = lazy(async () => await import('@/auth/components/GoogleOneTapLogin'))

export default memo(function Global() {
  const router = useRouter()

  useEffect(function initLiveAnnouncer() {
    // fixes for https://github.com/adobe/react-spectrum/issues/5191
    announce(' ', 'polite', 0)
  }, [])

  useEffect(
    function addSentryIntegration() {
      if (DEBUG) return
      addIntegration(tanstackRouterBrowserTracingIntegration(router))
      loadSentryIntegrations()
    },
    [router],
  )

  useScript({
    src: COBROWSE_SCRIPT,
    defer: true,
    // @ts-expect-error -- false is valid
    crossorigin: false,
    // @ts-expect-error -- false is valid
    referrerpolicy: false,
  })

  return (
    <>
      <InAppEffects />
      <LocaleUpdater />
      <ThemeEffects />
      <CssVariableEffects />
      <Toaster richColors />
      <AuthEffects />
      <BookmarkUpdater />
      <CartEffects />
      <RouteAnnouncer />
      <ReloadIfNotUsingStripeAnymore />
      {!isInApp() && (
        <Suspense>
          <GoogleOneTapLogin />
        </Suspense>
      )}
    </>
  )
})
